import React from 'react';
import {Col} from 'react-bootstrap';
import AbstractComponent from '../../AbstractComponent';

class InputLabel extends AbstractComponent {
    erro() {
        if(Array.isArray(this.props.erro)) {
            return(
                <ul>
                    {this.props.erro.map( (item , i) => {
                        return (
                            <li key={i}>{item}</li>
                        )
                    })}
                </ul>
            )
        }

        return this.props.erro;
    }

    classErro() {
        return this.props.erro !== undefined && this.props.erro !== '' ? 'form-controll-erro' : '';
    }    

    onChange(input) {        
        if (this.props.onChange !== undefined) {
          this.props.onChange(input);
        }
    }        

    classNameInput() {
        return this.props.classNameInput !== undefined ? this.props.classNameInput : '';
    }

    render() {
        return (
            <Col 
                md={this.props.md} 
                xs={this.props.xs} 
                sm={this.props.sm} 
                lg={this.props.lg} 
                style={this.props.style}               
            >
                <div className={this.classErro()}>
                    {
                        this.props.showChildren &&
                        <label htmlFor={this.props.nome} style={{height: '15px'}}>
                            {this.props.children}
                        </label>                    
                    }                    

                    <div 
                        className="row" 
                        style={{
                            marginLeft: '0px', 
                            marginRight: '0px',                            
                            display: 'block',
                            width: '100%',
                            height: '34px',
                            padding: '6px 12px',
                            fontSize: '14px',
                            lineHeight: '1.42857143',
                            color: '#555',
                            backgroundColor: '#fff',
                            backgroundImage: 'none',
                            border: '1px solid #ccc',
                            borderRadius: '4px'
                        }}>
                        <span className="span-block">
                            {this.props.value}
                        </span>
                    </div>
                    
                    {
                        this.props.showChildren &&
                        <div className="row" style={{marginLeft: '0px', marginRight: '0px'}}>
                            <span className="help-block">
                                {this.erro()}
                            </span>
                        </div>
                    }
                </div>
            </Col>
        )
    }
}

InputLabel.defaultProps = {
    md: 12,
    type: 'text',
    showChildren: true
};

export default InputLabel;